import storage from '@/utils/localStorage'
import axiosInstance from '@/api/api'
import {
  authStore
} from '@/mixins/authStoreMixin'
import store from '@/store'

const Auth = {
  install: async (Vue, options) => {
    const token = storage.getToken()

    if (!token) return

    axiosInstance.defaults.headers.common['Authorization'] = token // eslint-disable-line

    await store.dispatch(`${authStore.moduleName}/${authStore.actionTypes.ACTION_FETCH_USER}`)
  }
}

export default Auth
